<template>
    <div>
        <el-button type="warning" size="mini" @click="exportExcel()" style="margin-bottom: 10px;" >导出excel</el-button>
        <el-table  :data="tableData" size="small" style="margin-top: 0px;">
            <el-table-column type="index" width="50"> </el-table-column>
            <el-table-column prop="customerName" label="客户名称" :filters="customerNameList" :filter-method="filterHandler"> </el-table-column>
            <el-table-column prop="mblNo" label="提单号"  :filters="mblNoList" :filter-method="filterHandler"> </el-table-column>
            <el-table-column prop="containerId" label="箱号"  :filters="containerIdList" :filter-method="filterHandler"> </el-table-column>
            <el-table-column prop="containerType" label="箱型"  :filters="containerTypeList" :filter-method="filterHandler"> </el-table-column>
            <el-table-column prop="tracker" label="跟单人"  :filters="trackerList" :filter-method="filterHandler"> </el-table-column>
            <el-table-column prop="eta" label="到港日期"  :filters="etaList" :filter-method="filterHandler"> </el-table-column>
            <el-table-column prop="truckCompany" label="送货车队"  :filters="truckCompanyList" :filter-method="filterHandler"> </el-table-column>
            <el-table-column prop="truckNo" label="车号"  :filters="truckNoList" :filter-method="filterHandler"> </el-table-column>
            <el-table-column prop="overTime" label="超期天数"  :filters="overTimeList" :filter-method="filterHandler"> </el-table-column>
        </el-table>
    </div>
</template>
<script>
import req from '@/utils/index.js'
import url from '@/config/url2.js'
import ExcelJS from 'exceljs';

export default {
    data() {
        return {
            tableData:[],
            customerNameList:[],// 客户过滤
            mblNoList:[], // 提单号过滤
            containerIdList:[], // 箱号过滤
            containerTypeList:[], // 箱型过滤
            trackerList:[], // 跟单人过滤
            etaList:[], // 到港日期过滤
            truckCompanyList:[], // 送货车队过滤
            truckNoList:[], // 车号过滤
            overTimeList:[], // 超期天数过滤
        }
    },
     mounted() {
    //    this.getData()
    },
    methods: {
        getData(){
            let URL = `${url.deliveryReport}`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.tableData = res.data.data;
                    // 过滤数据
                    this.customerNameList = [
                        ...new Map(this.tableData.map (item => [item.customerName,{ text: item.customerName, value: item.customerName }])).values()
                    ]
                    this.mblNoList = [
                        ...new Map(this.tableData.map (item => [item.mblNo,{ text: item.mblNo, value: item.mblNo }])).values()
                    ]
                    this.containerIdList = [
                        ...new Map(this.tableData.map (item => [item.containerId,{ text: item.containerId, value: item.containerId }])).values()
                    ]
                    this.containerTypeList = [
                        ...new Map(this.tableData.map (item => [item.containerType,{ text: item.containerType, value: item.containerType }])).values()
                    ]
                    this.trackerList = [
                        ...new Map(this.tableData.map (item => [item.tracker,{ text: item.tracker, value: item.tracker }])).values()
                    ]
                    this.etaList = [
                        ...new Map(this.tableData.map (item => [item.eta,{ text: item.eta, value: item.eta }])).values()
                    ]
                    this.truckCompanyList = [
                        ...new Map(this.tableData.map (item => [item.truckCompany,{ text: item.truckCompany, value: item.truckCompany }])).values()
                    ]
                    this.truckNoList = [
                        ...new Map(this.tableData.map (item => [item.truckNo,{ text: item.truckNo, value: item.truckNo }])).values()
                    ]
                    this.overTimeList = [
                        ...new Map(this.tableData.map (item => [item.overTime,{ text: item.overTime, value: item.overTime }])).values()
                    ]
                }
            })
        },
        filterHandler(value, row, column) {
            const property = column['property'];
            return row[property] === value;
        },
        async exportExcel(){
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Sheet1');
            const columns = [
                { header: '客户名称', key: 'customerName', width: 20 },
                { header: '提单号', key: 'mblNo', width: 20 },
                { header: '箱号', key: 'containerId', width: 20 },
                { header: '箱型', key: 'containerType', width: 20 },
                { header: '跟单人', key: 'tracker', width: 20 },
                { header: '到港日期', key: 'eta', width: 20 },
                { header: '送货车队', key: 'truckCompany', width: 20 },
                { header: '车号', key: 'truckNo', width: 20 },
                { header: '超期天数', key: 'overTime', width: 20 },
            ];
              // 设置表头
            worksheet.columns = columns;
             // 添加数据行
            this.tableData.forEach(item => {
                worksheet.addRow(item);
            });

            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `${this.getFormattedDateTime()}`;
            link.click();
            window.URL.revokeObjectURL(url);
        },
        getFormattedDateTime() {
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const seconds = String(now.getSeconds()).padStart(2, '0');
            return `${year}-${month}-${day}_${hours}-${minutes}-${seconds}-未送货计划表`;
        },
    },
}


</script>